// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__ok9ta","rightAdornment":"Header_rightAdornment__Gpf-X"};